/**
* @description 浏览器COS上传组件
*/

import CosAuth from './cos-auth.js'
import CryptoJS from 'crypto-js' // 需要安装crypto-js依赖

// 请求用到的参数
const Region = 'ap-guangzhou';
// 私有桶
const Bucket = 'tme-yyrp-1253690380';
const prefix = 'https://' + Bucket + '.cos.' + Region + '.myqcloud.com';
// 公共桶
const BucketPublic = 'tme-yyr-1253690380';
const prefixPublic = 'https://' + BucketPublic + '.cos.' + Region + '.myqcloud.com';

/**
* @description 统一上传服务，支持各种文件
*/
export class Upload {
    constructor(opts) {
        if (!opts.file || !opts.fileType) {
            throw new Error('invalid option')
        }

        this.file = opts.file; // 源文件
        this.fileSize = opts.file.size; // 文件大小
        this.fileType = opts.fileType; // 文件类型
        this.storeType = +opts.storeType || 1; // 1表示私有桶 2表示公共桶
        this.urlAttachment = +opts.urlAttachment || 1; // url是否是一个下载流 1是，2不是

        this.sha1Complete = opts.sha1Complete || function () { }; // shal值回调
        this.successCallback = opts.success || function () { };  // 成功回调
        this.errorCallback = opts.error || function () { }; // 错误回调
        this.stopCallback = opts.stop || function () { }; // 网络中断回调
        this.progressCallback = opts.progress || function () { }; // 进度回调

        this.apiTimeStart = Date.now();  // 时间戳便于统计上传时长
        this.sha1 = '' // 文件sha1值

        window.addEventListener("offline", () => {
            this.stopCallback();
        });
    }

    // 计算文件sha1
    getFileSha1(cb) {
        const reader = new FileReader();
        reader.onload = () => {
            const wordArray = CryptoJS.lib.WordArray.create(reader.result);
            console.log(CryptoJS.SHA1(wordArray).toString());
            cb(CryptoJS.SHA1(wordArray).toString());
        };
        reader.readAsArrayBuffer(this.file);
    }

    // 发送日志
    handleStats(opts = {}) {
        let url = 'https://y.tencentmusic.com/other/stat.png?op_time=';
        try {
            url += new Date().getTime();
            url += '&client_type=mobile&from=kugou-h5';
            url += '&page_url=' + encodeURIComponent(document.location.href);
            url += '&refer=' + encodeURIComponent((document.referrer));
            for (let key in opts) {
                if (opts.hasOwnProperty(key)) {
                    url += ('&' + key + '=' + encodeURIComponent(opts[key]));
                }
            }
        } catch (e) { }
        let img = new Image();
        img.onerror = img.onabort = img.onload = function () {
            img = null;
        };
        img.src = url;
    }

    // 接口耗时日志发送
    sendApiTimeLog(time, sha1, size) {
        this.handleStats({
            urlKey: 'apitime',
            url: this.storeType === 2 ? prefixPublic : prefix,
            time,
            sha1,
            size
        });
    }

    // 上传失败日志发送
    sendApiErrorLog(sha1, size, reason, requestid) {
        this.handleStats({
            urlKey: 'uploadError',
            url: this.storeType === 2 ? prefixPublic : prefix,
            reason,
            sha1,
            size,
            requestid
        });
    }

    // 上传
    start() {
        if (!this.sha1) {
            this.getFileSha1(sha1 => {
                this.sha1 = sha1
                this.sha1Complete(sha1)
                this.startUpload()
            })
        } else {
            this.startUpload()
        }
    }

    // 计算签名 (注意：请求方式请走openapi，这里只是示意)
    getAuthorization(options, callback) {
        window.$req('getUploadSignature', { 
            storeType: this.storeType,
            pathName: options.Pathname,
            method: options.Method 
        }, { originRes: true }).then(res => {
            if (res && res.data && res.data.data && res.data.data.data) {
                callback(null, {
                  isRepeat: res.data.data.data.isRepeat,
                  XCosSecurityToken: res.data.data.data.sessionToken,
                  Authorization: res.data.data.data.authorization,
                });
            } else {
                callback(new Error('获取签名出错'));
            }
        }).catch(e => {
            callback(new Error('获取签名出错'));
        });
    }

    // 开始上传
    startUpload() {
        const self = this;
        let fileid = `cos_${this.sha1}.${this.fileType}`
        let Key = `/songFile/noUserId/${fileid}`
        if (this.storeType === 2) {
            fileid = `cos_${this.sha1}.${this.fileType}`
            Key = `/musician/commonPic/${fileid}`
        }
        this.getAuthorization({
            Method: 'PUT',
            Pathname: Key
        }, (err, info) => {
            if (err) {
                self.sendApiErrorLog(self.sha1, self.fileSize, err)
                self.errorCallback()
                return
            }
            const { isRepeat, XCosSecurityToken, Authorization } = info;
            // 已存在
            if (isRepeat) {
                self.progressCallback(100);
                self.successCallback({
                    got: fileid
                });
                return;
            }
            const url = (this.storeType === 2 ? prefixPublic : prefix) + Key;

            const xhr = new XMLHttpRequest();
            xhr.open('PUT', url, true);
            xhr.setRequestHeader('Authorization', Authorization);
            if (this.urlAttachment === 1) {
                xhr.setRequestHeader('Content-Disposition', `attachment; filename="${fileid}"; filename*=utf-8''${fileid}`)
            }
            if (XCosSecurityToken) {
                xhr.setRequestHeader('x-cos-security-token', XCosSecurityToken)
            }
            xhr.upload.onprogress = (e) => {
                self.progressCallback(Math.round(e.loaded / e.total * 10000) / 100)
            };
            xhr.onload = () => {
                if (xhr.status === 200 || xhr.status === 206) {
                    self.progressCallback(100);
                    self.sendApiTimeLog(Date.now() - self.apiTimeStart, self.sha1, self.fileSize);
                    self.successCallback({
                        etag: xhr.getResponseHeader('etag'),
                        got: fileid
                    });
                } else {
                    self.sendApiErrorLog(self.sha1, self.fileSize, `文件${Key}上传失败，状态码：${xhr.status}`, xhr.getResponseHeader('x-cos-request-id'))
                    self.errorCallback()
                }
            };
            xhr.onerror = () => {
                self.sendApiErrorLog(self.sha1, self.fileSize, `文件${Key}上传失败，上传失败，请检查是否没配置CORS跨域规则`, xhr.getResponseHeader('x-cos-request-id'))
                self.errorCallback()
            };
            xhr.send(self.file);
        });
    }
}

/**
* @description 获取文件对应的url (注意：请求方式请走openapi，这里只是示意)
* @param {string} fileid cos对应的fileid
* @return {promise}
*/
export const getUrlByFileid = (fileid = '') => {
    return new Promise((resolve, reject) => {
        if (!fileid) {
            reject('fileid不存在')
        }
        window.$req('getUploadCosUrl', { fileId: fileid }, { originRes: true }).then((oRes) => {
            let fRes = oRes.data
            if (fRes.errcode === 0) {
                resolve(fRes.data.data)
            } else {
                reject('获取音频播放链接失败')
            }
        }).catch(() => {
            reject('获取音频播放链接失败')
        })
    })
}

/**
* @description 上传图片
* @param {Function} success 上传成功回调，参数：图片url
* @param {Function} error 上传失败回调，参数：错误原因
* @param {Function} progress 进度回调，参数：进度数字（相对100）如 12 -> 12%
* @param {Number} storeType 桶的类型，1 私有 2 公共 默认2
* @param {String} imageType 图片类型，例如 png
* @param {File} image 图片源文件
*/
export default (opts = {}) => {

    if (!opts.image || !opts.imageType) {
        return
    }

    const successCallback = typeof opts.success === 'function' ? opts.success : function () { }
    const errorCallback = typeof opts.error === 'function' ? opts.error : function () { }
    const progressCallback = typeof opts.progress === 'function' ? opts.progress : function () { }
    const storeType = +opts.storeType || 2 // 默认是公共桶

    new Upload({
        file: opts.image,
        fileType: opts.imageType,
        storeType,
        urlAttachment: 2,
        stopCallback: () => {
            errorCallback('网络中断')
        },
        error: () => {
            errorCallback('上传失败')
        },
        success: data => {
            if (storeType === 1) {
                getUrlByFileid(data.got).then(url => {
                    successCallback(url)
                }).catch(() => {
                    errorCallback('获取url失败')
                })
            } else {
                successCallback(`//tme-yyr-1253690380.cos.ap-guangzhou.myqcloud.com/musician/commonPic/${data.got}`)
            }
        },
        progress: progress => {
            progressCallback(progress)
        }
    }).start()

}